import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./model.css";

export const AskpageNumber = ({
  showModal,
  closePopUp,
  totalpage,
  setFirstSelectedPage,
  firstSelectedPage,
  exportAllFile,
  secondSelectedPage,
  setSecondSelectedPage,
  selectOption,
  setSelectOption,
  customPage,
  setCustomPage,
}) => {
  let pageLength = totalpage || 0;
  const checkDisable = () => {
    let disabled = true;
    if (selectOption == "All") {
      disabled = false;
    } else if (
      selectOption == "Custom" &&
      firstSelectedPage !== undefined &&
      secondSelectedPage !== undefined &&
      !(secondSelectedPage > pageLength) &&
      !(firstSelectedPage > secondSelectedPage)
    ) {
      disabled = false;
    }
    return disabled;
  };
  const checkedHandler = (e) => {
    setFirstSelectedPage(e.target.value);
    setSelectOption("All");
    setSecondSelectedPage();
    setCustomPage("");
  };
  const customPageHandle = () => {
    setSelectOption("Custom");
  };
  //console.log("firstSelectedPage", firstSelectedPage);
  //console.log("secondSelectedPage", secondSelectedPage);
  const pageChnagehandler = (e) => {
    const { value } = e.target;
    setSelectOption("Custom");
    setCustomPage(value);
    var splitValues = value.split("-");
    //console.log("splitValues", splitValues);
    let checkFnun = Number.isNaN(+splitValues[0]);
    let checkSecnun = Number.isNaN(+splitValues[1]);
    if (!checkFnun && splitValues[0] !== undefined && splitValues[0] !== "") {
      //console.log("splitValues[0]", splitValues[0]);
      setFirstSelectedPage(+splitValues[0]);
    } else if (
      !checkFnun &&
      splitValues[0] !== undefined &&
      splitValues[0] == ""
    ) {
      setFirstSelectedPage();
      setSecondSelectedPage();
    }

    if (
      !checkSecnun &&
      +splitValues[1] !== undefined &&
      splitValues[1] !== ""
    ) {
      setSecondSelectedPage(+splitValues[1]);
    }
  };
  return (
    <Modal show={showModal}>
      <div class="modal-content  alerttext">
        <div class="modal-header">
          <h5 id="">Select Page</h5>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12 mb-4">
              <div class="form-checkbox">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="gender"
                    checked={selectOption === "All"}
                    onClick={checkedHandler}
                    id="male"
                    value={pageLength}
                  />
                  <label class="form-check-label" for="male">
                    ALL PAGES
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-8 mb-2">
              <div class="form-checkbox">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="gender"
                    checked={selectOption === "Custom"}
                    onClick={customPageHandle}
                    id="male"
                    value="Custom"
                  />
                  <input
                    type="text"
                    class="form-control"
                    id="categoryCode"
                    placeholder="Eg. 1-3"
                    name="gender"
                    onChange={pageChnagehandler}
                    value={customPage}
                  />
                  {firstSelectedPage !== undefined &&
                  firstSelectedPage > pageLength ? (
                    <small style={{ color: "red" }}>
                      Out of bounds page reference, Limit is {pageLength}
                    </small>
                  ) : secondSelectedPage !== undefined &&
                    secondSelectedPage > pageLength ? (
                    <small style={{ color: "red" }}>
                      Out of bounds page reference, Limit is {pageLength}
                    </small>
                  ) : (
                    ""
                  )}
                  {firstSelectedPage !== undefined &&
                    secondSelectedPage !== undefined &&
                    firstSelectedPage > secondSelectedPage && (
                      <small style={{ color: "red" }}>
                        First number should lesser than second
                      </small>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <Button onClick={closePopUp} variant="secondary" size="sm">
            Cancel
          </Button>
          <Button
            disabled={checkDisable()}
            onClick={() => exportAllFile()}
            variant={checkDisable() ? "secondary" : "primary"}
            size="sm"
          >
            Export File
          </Button>
        </div>
      </div>
    </Modal>
  );
};
